<template>
  <el-dialog class="k-point-edit-form" :title="point && point._id ? `Редактирвание акции ${point._id}` : 'Создание новой акции'" :visible.sync="dialogFormVisible">
    <div class="k-point-edit-form__container">
      <p class="k-point-edit-form__title">Вы можете отредактирвать информацию об акции. И сохранить ее в базе данных:</p>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Название акции:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="title"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Описание акции:</el-col>
        <el-col :span="16"><el-input placeholder="Описание акции" v-model="description" type="textarea" :rows="4"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Адрес:</el-col>
        <el-col :span="16"><el-input placeholder="Адрес" v-model="address"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Широта (lat):</el-col>
        <el-col :span="16"><el-input placeholder="Широта" v-model="lat"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Долгота (lng):</el-col>
        <el-col :span="16"><el-input placeholder="Долгота" v-model="lng"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Дата старта:</el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="Pick a day">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Дата окончания:</el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="Pick a day">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-button type="success" round @click="handleSave" size="mini">Сохранить</el-button>
        <el-button round @click="handleCancel" size="mini">Отмена</el-button>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
/**
 * Component: k-point-edit-form - Форма для редактирования информации о токене
*
* @version 1.0.0
*/

const toStr = param => param ? param : '';
const toBool = param => param ? param : true;

export default {
  name: 'k-point-edit-form',

  props: {
    // Является ли форма видимой
    dialogFormVisible: {
      type:Boolean,
      required: true,
    },

    // Данные точки для отображения
    point: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      title: '',
      description: '',
      address: '',
      lng: '',
      lat: '',
      startDate: null,
      endDate: null,
    };
  },

  watch: {
    point: {
      handler: function(newValue) {
        this.setPointData();
      },
      deep: true,
    },
  },

  created() {
    if (this.point) {
      this.setPointData();
    }
  },

  methods: {
    setPointData() {
      this.title = this.point.title ? this.point.title : '';
      this.description = this.point.description ? this.point.description : '';
      this.address = this.point.address ? this.point.address : '';
      this.lng = this.point.lng ? this.point.lng : '';
      this.lat = this.point.lat ? this.point.lat : '';
      this.startDate = this.point.startDate ? this.point.startDate : null;
      this.endDate = this.point.endDate ? this.point.endDate : null;
    },

    // Отмена редактирования токена
    handleCancel() {
      this.$emit('cancel');
    },

    // Сохранение информации о токене на бекенде
    async handleSave() {
      const point = {
        title: this.title,
        description: this.description,
        address: this.address,
        lng: this.lng,
        lat: this.lat,
        startDate: this.startDate,
        endDate: this.endDate,
      };

      if (this.point._id) {
        point._id = this.point._id;
      }

      await this.setPoint(point);
      this.$emit('cancel');
    },

    ...mapActions({
      setPoint: 'points/setPoint',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-point-edit-form {
  $this: &;
  $icon-size: 50px;

  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__title {
    margin-bottom: 2 * $vp;
  }

  &__param {
    margin-bottom: $vp;
  }

  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }

  &__icon {
    width: $icon-size;
    height: $icon-size;
    margin: 10px auto;
    border-radius: $icon-size / 2;
    background-color: black;

    & svg {
      width: $icon-size;
      height: $icon-size;
    }
  }
}
</style>
